import * as types from './actionTypes';

export default status => ({ type: types.SET_LOADING, status });
